import { useCallback, useEffect, useState } from "react";
import type { CafeLog } from "../types";
import { api } from "../lib/api";

export function useCafeLogs(params: Record<string, string> = {}) {
  const [data, setData] = useState<CafeLog[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const key = JSON.stringify(params);

  const refresh = useCallback(() => {
    setError(null);
    api.cafeLogs.list(params).then(setData).catch((e: Error) => setError(e.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => { refresh(); }, [refresh]);

  return { data, error, refresh };
}

export function useCafeLog(id: number | null) {
  const [data, setData] = useState<CafeLog | null>(null);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(() => {
    if (id === null) return;
    setError(null);
    api.cafeLogs.get(id).then(setData).catch((e: Error) => setError(e.message));
  }, [id]);

  useEffect(() => { refresh(); }, [refresh]);

  return { data, error, refresh, setData };
}
